<template>
    <div>
        <Modal :loading="loading" v-model="showModel" :width="750" :title="title" @on-ok="save" @on-cancel="closeModel"
            :footer-hide="disabled">
            <div>基本信息</div>
            <div class="box">
                <div class="flex">
                    <div class="label">保险公司</div>
                    <div class="content">{{ model.bankName }}</div>
                </div>
                <div class="flex">
                    <div class="label">贷款产品名称</div>
                    <div class="content">{{ model.productName }}</div>
                    <div class="label">担保方式</div>
                    <div class="content">{{ model.guaranteeWay }}</div>
                </div>
                <div class="flex">
                    <div class="label">利率范围</div>
                    <div class="content">{{ model.rate}}</div>
                    <div class="label">贷款期限(月)</div>
                    <div class="content">{{ model.timeLimit }}</div>
                </div>
                <div class="flex">
                    <div class="label">贷款额度(万元)</div>
                    <div class="content">{{ model.amount }}</div>
                    <div class="label" style="background: #fff;"></div>
                    <div class="content"></div>
                </div>

                <div class="flex">
                    <div class="label">项目详情</div>
                    <div class="content">{{ model.detail }}</div>
                </div>
                <div class="flex">
                    <div class="label">适用对象</div>
                    <div class="content">{{ model.target }}</div>
                </div>
                <!-- <div class="flex">
                    <div class="label">产品活动时间</div>
                    <div class="content" v-if="model.actTimeLimit==1">无限制</div>
                    <div class="content" v-else>{{ model.startTime }}至{{ model.endTime }}</div>
                </div> -->
            </div>
            <!-- <el-select v-model="auditStatus" style="width:100%;margin-top:20px"
                v-if="!(model.auditStatus == '1' && disabled)" :disabled="disabled">
                <el-option :key="audit.id" v-for="audit in auditStatusList" :label="audit.name" :value="audit.id">
                </el-option>
            </el-select> -->
            <Select
              style="width:100%;margin-top:20px;"
              v-model="auditStatus"
              v-if="!(model.auditStatus == '1' && disabled)"
              :disabled="disabled">
              <Option v-for="audit in auditStatusList" :label="audit.name" :value="audit.id" :key="audit.id"></Option>
            </Select>
            <el-input :disabled="disabled" v-if="auditStatus == 3" type="textarea" :rows="3" v-model="model.reason"
            show-word-limit :maxlength="200"
                placeholder="请输入驳回原因" style="width:100%;margin-top:20px"></el-input>
        </Modal>
    </div>
</template>

<script>
import util from '@/libs/util.js';

export default {
    name: 'bank-audit',

    props: {
        title: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            auditStatus: '2',
            auditStatusList: [
                // { id: "1", name: '审核中' },
                { id: "2", name: '通过' },
                { id: '3', name: '驳回' },
            ],
            uploadUrl: util.baseUrl + "api/common/upload",
            //ID
            id: null,
            loading: true,
            showModel: false,
            //表单参数
            model: {
                id: null,
                bankId: null,
                productName: null,
                guaranteeWay: null,
                minRate: null,
                maxRate: null,
                timeLimit: null,
                amount: null,
                type: null,
                detail: null,
                target: null,
                actTimeLimit: '1',
                startTime: null,
                endTime: null,
                chooseDate: [],
                rowDate: [],
            },

            disabled: false,
            headers: {
                Authorization: localStorage.token,
            },
        };
    },
    mounted() {
    },
    methods: {
        save() {
            console.log('ok')
            if (this.auditStatus == '3' && !this.model.reason) {
                // this.$message.warning('请输入驳回原因')
                this.$Message['warning']({
                    background: true,
                    content: '请输入驳回原因'
                })
                this.loading = false
                setTimeout(() => {
                    this.loading = true;
                }, 200)

                return
            }
            util.http.post("/api/bank/product/audit", {
                id: this.model.id,
                auditStatus: this.auditStatus,
                reason: this.model.reason
            })
                .then((response) => {
                    if (response.data.code === 200) {
                        this.$Notice.success({
                            title: '保存成功!'
                        });
                        this.$emit('ok')
                        this.closeModel()
                    } else {
                        this.$Notice.success({
                            title: response.data.message
                        });
                        this.loading = false;
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                    }
                })
        },

        radioChange() {
            if (this.model.actTimeLimit === 1) {
                this.model.chooseDate = []
            } else {
                this.model.chooseDate = this.model.rowDate
            }
        },
        clearDate() {
            this.model.chooseDate = []
        },

        openModel() {
            this.showModel = true
        },
        closeModel() {
            this.model = {
                id: null,
                bankId: null,
                productName: null,
                guaranteeWay: null,
                minRate: null,
                maxRate: null,
                timeLimit: null,
                amount: null,
                type: null,
                detail: null,
                target: null,
                actTimeLimit: '1',
                startTime: null,
                endTime: null,
                chooseDate: [],
                rowDate: [],
            }
            this.loading = true
            this.showModel = false
            this.auditStatus = '2'
        },

    }
};
</script>

<style scoped>
.flex {
    display: flex;

}

.label {
    border-top: 1px solid #BFBFBF;
    border-right: 1px solid #BFBFBF;
    width: 200px;
    /* height: 50px; */
    background: rgb(240, 240, 240);
    text-align: right;
    /* line-height: 50px; */
    padding-right: 4px;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.content {
    border-top: 1px solid #BFBFBF;
    border-right: 1px solid #BFBFBF;
    flex: 1;
    /* line-height: 50px; */
    text-align: center;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
}

.box {
    border: 1px solid #BFBFBF;
    margin-top: 20px;
}
</style>
